<script lang="ts">
export default {
  name: 'CompaniesRpaErrorLogs',
}
</script>
<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import { storeToRefs } from 'pinia'
import { KkBox, KkLoading } from '../components/base'
import { KkInfo } from '../components/ui'
import { useRpaErrorLogsStore } from '../new_stores/rpaErrorLogs'

const { t } = useI18n()
const route = useRoute()
const rpaErrorLogsStore = useRpaErrorLogsStore()
const { rpaErrorLogs, rpaErrorLogsLoading } = storeToRefs(rpaErrorLogsStore)
const { readRpaErrorLogs } = rpaErrorLogsStore
const companyUuid = computed<string>(() => route.params.company_uuid as string)

readRpaErrorLogs(companyUuid.value)
</script>
<template>
  <KkLoading v-if="rpaErrorLogsLoading" />
  <KkBox v-else>
    <template #content>
      <KkInfo>
        {{ t('pages.CompaniesRpaErrorLogs.info1') }}
        <router-link :to="{ name: 'CompaniesMailNotificationSetting', params: { company_uuid: companyUuid } }" class="link">
          {{ t('pages.CompaniesRpaErrorLogs.info2') }}
        </router-link>
      </KkInfo>
      <template v-if="rpaErrorLogs.length">
        <p class="description">
          {{ t('pages.CompaniesRpaErrorLogs.exist', { count: rpaErrorLogs.length }) }}
        </p>
        <div class="errors">
          <table>
            <thead>
              <tr>
                <th>{{ t('pages.CompaniesRpaErrorLogs.tableHeaders.store') }}</th>
                <th>{{ t('pages.CompaniesRpaErrorLogs.tableHeaders.site') }}</th>
                <th>{{ t('pages.CompaniesRpaErrorLogs.tableHeaders.content') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="log in rpaErrorLogs" :key="`${ log.storeName }_${ log.kind }`">
                <th class="errors__store">{{ log.storeName }}</th>
                <td class="errors__site">{{ log.kind }}</td>
                <td class="errors__content">
                  <p>{{ log.errorMessage }}</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>
      <p v-else class="description">{{ t('pages.CompaniesRpaErrorLogs.notExist') }}</p>
    </template>
  </KkBox>
</template>
<style lang="scss" scoped>
@import '../../../stylesheets/biz_spa/foundation/_var.scss';
.description {
  margin-top: 32px;
  font-weight: bold;
  font-size: 12px;
}
.link {
  color: $color-accent-primary;
}
.errors {
  overflow-x: auto;
  margin-top: 16px;
  &::-webkit-scrollbar {
    height: 8px;
  }
  &::-webkit-scrollbar-track {
    border-radius: 4px;
    background-color: rgba($color-accent-primary, .15);
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: $color-accent-primary;
  }
  table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
  }
  thead {
    th {
      padding: 15px 16px;
      border-bottom: 8px;
      background-color: #ecedf0;
      font-weight: bold;
      font-size: 12px;
      text-align: left;
      white-space: nowrap;
      &:first-child {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }
      &:last-child {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }
    }
  }
  tbody {
    &::before {
      content: "";
      display: block;
      height: 8px;
    }
    th, td {
      padding: 24px 16px;
      border: 1px solid #E4E7EB;
      font-weight: normal;
      font-size: 14px;
      line-height: 1.72;
      text-align: left;
    }
    th {
      background-color: #F8F9FA;
    }
  }
  &__store {
    min-width: 240px;
  }
  &__site {
    min-width: 240px;
  }
  &__content {
    min-width: 320px;
    p {
      position: relative;
      padding-left: 16px;
      color: $color-accent-primary;
      &::before {
        content: "";
        position: absolute;
        top: 8px;
        left: 0;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: $color-accent-primary;
      }
    }
  }
}
</style>
